import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-confirmation-details',
    templateUrl: './order-confirmation-details.component.html',
    styleUrls: ['./order-confirmation-details.component.scss'],
    standalone: false
})
export class OrderConfirmationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
